import type { DatePickerSlotProps } from "@mui/x-date-pickers";

export const datePickerDefaultOptions: DatePickerSlotProps<Date, false> = {
  inputAdornment: {
    position: 'start',
  },
  field: { clearable: true },
  layout: {
    sx: {
      '& .MuiPickersCalendarHeader-labelContainer': {
        fontSize: '1.6rem',
      },
      '& .MuiButtonBase-root': {
        fontSize: '1.2rem',
      },
      '& .MuiPickersArrowSwitcher-button': {
        fontSize: '2.5rem !important',
      },
      '& .MuiTypography-root': {
        fontSize: '1.2rem',
      },
      '& .MuiPickersYear-yearButton': {
        fontSize: '1.2rem',
      },
    },
  },
  textField: {
    sx: {
      width: '100%',
      color: '#555555',
    },
  },
};

export const convertDateToUTCISOString = (value: Date) => {
  return new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate())).toISOString();
};
